export const environment = {
  production: true,
  socket: '/websocket/websocket',
  referralURL: '/referral_register?referralToken=',
  simple: window.location.hostname.startsWith('prices.'),
};
